export const environment = {
  production: true,
  apiKey: '7bd88321-6b31-11e7-a616-42010a8a0005',
  apiRoot: 'https://api.dreamjobs.com.co/v1',
  apiGoogleKey: 'AIzaSyDiDWCREgYDr71JzCDISN5-CRC8LleVS1M'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts